import atomize from '@quarkly/atomize';
import { commonTextProps, commonTextPropsDefaults } from './text';
var config = {
  name: 'I',
  normalize: true,
  mixins: true,
  description: {
    en: 'Italic text',
    ru: 'Italic text'
  },
  propInfo: commonTextProps
};
export var Em = atomize.em(config, commonTextPropsDefaults);
export var I = atomize.i(config, commonTextPropsDefaults);